import { VehicleDetailsView } from 'common/constants'
import { UnwatchPlaceholder } from 'modules/Watchlist/UnwatchPlaceholder'
import { useContext } from 'react'

import { StyledBidBuyInfoSection, StyledVehicleDetailsGridCard } from './VehicleDetailsGridCard.styled'
import { VehicleDetailsGridCardImage } from './VehicleDetailsGridCardImage'
import { VehicleNote } from './VehicleNote'
import { StyledVehicleDetailsColumn } from 'modules/VehicleList'
import { VehicleTitleSection } from './VehicleTitleSection'
import { VehicleProperties } from './VehicleProperties'
import { VehicleActions } from './VehicleActions'
import { VehicleVin } from './VehicleDetails.styled'
import { IVehicleDetailsProps } from './VehicleDetails'
import { VehicleContext } from './VehicleContext'
import { StyledVehicleBidBuyInformation } from 'modules/BuyerActivity/VehicleAuction.styled'
import { VehiclePriceSection } from './VehiclePriceSection'
import { VehicleTags } from './VehicleTags'
import { VehicleBidHistoryLink } from './VehicleBidHistoryLink'
import { VehicleTimer } from './VehicleTimer'
import { VehicleBidBuyActions } from './VehicleBidBuyActions'
import { UserMaxBid } from './UserMaxBid'
import { useGlobalStore } from 'store/useGlobalStore'
import { StockwaveData } from 'modules/Stockwave/StockwaveData'

export const VehicleGridLayout = ({ vehicleData, enableRemovedWatchlistPlaceholder }: IVehicleDetailsProps) => {
  const { getSystemSetting } = useGlobalStore()
  const { vehicle: vehicleInfo } = vehicleData
  const {
    vehicleData: {
      vehicle: { WatchListID }
    }
  } = useContext(VehicleContext)

  const fieldLimit = (getSystemSetting('BGD_GRIDVIEW_VEHICLE_DETAILS_DISPLAY_FIELDS_LIMIT') as number) || null

  if (!WatchListID && enableRemovedWatchlistPlaceholder) {
    return (
      <StyledVehicleDetailsGridCard>
        <UnwatchPlaceholder vehicleInfo={vehicleInfo} viewStyle={VehicleDetailsView.Grid} />
      </StyledVehicleDetailsGridCard>
    )
  }

  return (
    <StyledVehicleDetailsGridCard>
      <StyledVehicleDetailsColumn className="stockwave-vehicle-row stockwave-highlight-element">
        <div className="vehicle-detail-image-section">
          <div className="stockwave-light-bulb-container" id={`vehicle_${vehicleData.vehicle.VIN}`}></div>
          <StockwaveData vehicleData={vehicleData} />
          <VehicleDetailsGridCardImage
            images={vehicleInfo.Images}
            vehicleInstanceID={vehicleData.vehicle.InstanceID}
            isDSI={vehicleData.vehicle.IsSellerDisclosure}
          />
        </div>
        <VehicleActions vehicleData={vehicleData} />
        <VehicleTitleSection vehicleData={vehicleData} />
        <VehicleVin>{vehicleData.vehicle.VIN}</VehicleVin>
        <VehicleProperties vehicleInfo={vehicleData.vehicle} fieldLimit={fieldLimit} />
        <VehicleNote />
        <StyledVehicleBidBuyInformation>
          <StyledBidBuyInfoSection>
            <div className="text-left d-flex flex-column justify-content-end">
              <VehicleTags direction="right" />
              <VehicleTimer />
            </div>
            <div>
              <VehicleBidHistoryLink />
              <UserMaxBid />
              <VehiclePriceSection />
            </div>
          </StyledBidBuyInfoSection>
          <VehicleBidBuyActions />
        </StyledVehicleBidBuyInformation>
      </StyledVehicleDetailsColumn>
    </StyledVehicleDetailsGridCard>
  )
}
